import { render, staticRenderFns } from "./MPopupImgTrimming.vue?vue&type=template&id=40568c7f&"
import script from "./MPopupImgTrimming.vue?vue&type=script&lang=ts&"
export * from "./MPopupImgTrimming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports